import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';

import { FormModal } from '@/shared/presentation/components/ui/FormModal';
import { Input } from '@/shared/presentation/components/ui/Input';
import { Loading } from '@/shared/presentation/components/ui/Loading';
import { PhoneInput } from '@/shared/presentation/components/ui/PhoneInput';
import { TagInput } from '@/shared/presentation/components/ui/TagInput';

import { CreateUserViewModel } from './CreateUser.vm';

const CreateUserForm = observer(() => {
  const vm = useViewModel(CreateUserViewModel);

  return (
    <>
      <Input
        label="Nome completo"
        name="name"
        errorMessage={vm.form.errors.name && vm.form.errors.name[0]}
        onChange={(value) => vm.form.setValue('name', value)}
        onBlur={() => vm.form.validateField('name')}
        value={vm.form.values.name}
      />
      <Input
        label="Email"
        name="email"
        errorMessage={vm.form.errors.email && vm.form.errors.email[0]}
        onChange={(value) => vm.form.setValue('email', value)}
        onBlur={() => vm.form.validateField('email')}
        value={vm.form.values.email}
      />
      <PhoneInput
        label="Telefone"
        placeholder="21999999999"
        name="phone"
        errorMessage={vm.form.errors.phone && vm.form.errors.phone[0]}
        onChange={(value) => {
          vm.form.setValue('phone', value);
        }}
        onBlur={() => vm.form.validateField('phone')}
        value={vm.form.values.phone}
      />
      <Input
        label="Senha"
        type="password"
        name="password"
        errorMessage={vm.form.errors.password && vm.form.errors.password[0]}
        onChange={(event) => vm.form.setValue('password', event)}
        onBlur={() => vm.form.validateField('password')}
      />
      <TagInput
        label="Papel"
        name="roles"
        isMulti={false}
        onChange={(values) => {
          vm.form.setValueAndValidateValue('role', values?.[0]);
        }}
        defaultValue={
          vm.form.values.role
            ? [
                {
                  guid: vm.form.values.role.guid,
                  name: vm.form.values.role.name,
                },
              ]
            : []
        }
        options={vm.roles.map((role) => ({
          guid: role.guid,
          name: role.name,
        }))}
      />
      <TagInput
        label="Escopos"
        name="scopes"
        isMulti
        onChange={(value) => {
          vm.form.setValueAndValidateValue('scopes', value);
        }}
        defaultValue={vm.form.values.scopes.map((role) => ({
          guid: role.guid,
          name: role.name,
        }))}
        options={vm.scopes.map((role) => ({
          guid: role.guid,
          name: role.name,
        }))}
      />
    </>
  );
});

export const CreateUserScreen = observer(() => {
  const vm = useViewModel(CreateUserViewModel);

  const renderContent = () => {
    if (vm.isLoading) {
      return <Loading />;
    }

    if (vm.hasError) {
      return <div>Erro ao carregar formulário</div>;
    }

    return <CreateUserForm />;
  };

  if (!vm.isCreateModalOpen) {
    return null;
  }

  return (
    <FormModal
      title="Adicionar conta"
      onClose={() => vm.closeCreateModal()}
      onSubmit={() => vm.create()}
      isSubmitting={vm.isSubmitting}
      isValid={vm.form.isValid}
    >
      {renderContent()}
    </FormModal>
  );
});
